export const x_extent = [-2.5, 2.5]
export const y_extent = [-2.5, 3.5]
export const z_extent = [5, 0]

export const x_step = 1
export const y_step = 3
export const z_step = -1

function getXYBins(xy_bucket) {
    const x_bins = createBins(
        xy_bucket,
        'location_x',
        x_extent[0],
        x_extent[1],
        x_step
    )

    const xy_bins = x_bins.map((bin, idx) => ({
        idx,
        bins: createBins(bin, 'location_y', y_extent[0], y_extent[1], y_step),
    }))

    return xy_bins
}

function getXZBins(xz_bucket) {
    const x_bins = createBins(
        xz_bucket,
        'location_x',
        x_extent[0],
        x_extent[1],
        x_step
    )

    const xz_bins = x_bins.map((bin, idx) => ({
        idx,
        bins: createBins(bin, 'location_z', z_extent[0], z_extent[1], z_step),
    }))

    return xz_bins
}

function flattenNestedBins(nested_bins) {
    return nested_bins.reduce((acc, curr) => {
        const { idx, bins } = curr

        const flat_bins = bins.map((bin, y_idx) => ({ x_idx: idx, y_idx, bin }))

        return acc.concat(flat_bins)
    }, [])
}

export function getBins(data) {
    // split data into 2 (in the dirt/on the fly)
    // in the dirt
    const xy_bucket = data.filter((player) => player.is_pitch_ground)
    // on the fly
    const xz_bucket = data.filter((player) => !player.is_pitch_ground)

    // Includes all possible bins in nested array
    const xy_bins = getXYBins(xy_bucket)
    const xz_bins = getXZBins(xz_bucket)

    // Flatten bins into single array
    const xy_bins_flat = flattenNestedBins(xy_bins)
    const xz_bins_flat = flattenNestedBins(xz_bins)

    return {
        xy_bins,
        xz_bins,
        xy_bins_flat,
        xz_bins_flat,
    }
}

function createBins(data, accessor, min, max, increment) {
    const num_bins = Math.ceil((max - min) / increment)
    const bins = Array(num_bins)
        .fill(0)
        .map(() => [])

    data.forEach((d) => {
        const val = d[accessor]
        const diff = val - min

        let idx = Math.floor(diff / increment)
        if (idx < 0) {
            idx = 0
        } else if (idx > num_bins - 1) {
            idx = num_bins - 1
        }

        bins[idx].push(d)
    })

    return bins
}
